<app-bar [queGame]="' '"></app-bar>


<div onkeypress="validar(event)">

<div class="controles">
  <div class="tcontroles">
    <p class="cderecha"> > </p>
    <span class="cizquierda">  < </span>
    <div class="s"></div>
  </div>
</div>


<div onclick="mygame();" class="logo" id="here">



  <div class="contenedor_creditos">

    <img src="../assets/images/intro.gif" class="logoImagen" />


    <br />

    <strong> Press Enter</strong>
    <br />
    <br />
    <p class="credits "><strong>Songs:</strong>
      <br />
      <br />
      kyodai-mahjongg-1842 <br /> parabens-deck-of-cards
    </p>
    <br />
    <br />
    <br />
    <p class="credits">

      Game Off is an annual game jam, where participants spend the month of November creating games based on a secret theme.

      The theme for this year’s Game Off is <strong>MOONSHOT</strong>
    </p>

  </div>



</div>

<div class="contenedorx">
<div class="containerx center-h center-v">
  <div class="juego">
    <canvas id="canvas" width="360" height="700">YOUR BROWSER DOES NOT SUPPORT HTML5!</canvas>
  </div>
</div>
</div>


<div style="" id="audios">
  <audio id="audioUno"  loop> <source src="../assets/images/kyodai-mahjongg-1842-keygen-music.mp3"  type="audio/mp3"></audio>
    <audio id="audioDos"  loop> <source src="../assets/images/parabens-deck-of-cards-10-keygen-music.mp3"  type="audio/mp3"></audio>
</div>
</div>


